export default "__VITE_ASSET__Bvg0bqfp__"